export default __webpack_public_path__ + "static/media/pr.a70db419.svg";